const pick = (ndx, arr) => {
  if (ndx >= 0)
    return arr[ndx % arr.length];
  return arr[Math.abs(ndx + arr.length) % arr.length];
};
var pick_default = pick;
export {
  pick_default as default
};
